export default "Opérations CEE industrielles — Utilités & bâti IND-UT/IND-BA | Solution Éco France";
